import { private_server } from '../../utils/axios';
import { USER_TYPES } from '../../utils/enums';
import { onGetUserTypeFromToken } from '../../utils/general';


const usePatientData = () => {   

    const actions = {
        // Get list of all users
        onGet: async(idpatientdata) => {

            const userType = onGetUserTypeFromToken()
            let request

            let result = null
            if(userType === USER_TYPES.ADMIN){
                request = await private_server.get(`/patientdata/${idpatientdata}`)
            }else{
                request = await private_server.get(`/patientdata/${idpatientdata}/nutritionist`)
            }
            
            result = request.data.data.patient_data
            return result
        },
        onGetPatientDatasByClient:async(client_id) => {
            let patients = []
        
            try{
                const params = {
                    limit:5000, offset:0,
                    order:0, filter:JSON.stringify({AND:[
                        //{field:'nutritionist_id', operator:"=", value:from_nutritionist},
                        {field:'client_id', operator:"=", value:client_id},
                    ]})
                }
            
                const _patients = await private_server.get('/patientdata/all', {params:params})
                patients = _patients.data.data.patient_datas
            }catch(error){
                console.log("Error al obtener los pacientes del cliente")
                console.log(error)
            }
        
            
        
            return patients
        },
        onGetMe: async() => {
            let result = null
            const request = await private_server.get(`/patientdata/me`)
            result = request.data.data.patient_data
            return result
        },
        onEdit: async(idpatientdata, data2send) => {
            const userType = onGetUserTypeFromToken()
            if(userType === USER_TYPES.ADMIN){
                await private_server.patch(`/patientdata/${idpatientdata}`, data2send)
            }else{
                await private_server.patch(`/patientdata/${idpatientdata}/nutritionist`, data2send)
            }
            
        },

    }

    return {
        actions
    }
}
 
export default usePatientData;